// import FileUpload from '../../../sharedComponents/FileUpload';
import AudioRecorder from '../../../sharedComponents/AudioRecorder/AudioRecorder';

export default ({
  soefiaConfig = {},
  currentQuestionStep,
  questionId,
  answers,
  setAnswers,
  largeFonts,
  extraLargeFonts,
  setIsRecordingInProgress
}) => {
  const { prompts = [] } = soefiaConfig;

  // prompt index is always 1 less then then current step
  const currentPromptIndex = (currentQuestionStep - 1)

  const currentPrompt = prompts[currentPromptIndex] || {}

  const {
    id: promptId,
    question,
    autoStartRecording
  } = currentPrompt;

  const promptQuestionFontSize = extraLargeFonts ? '46px' : largeFonts ? '34px' : '22px'

  const answerObj = answers[questionId] || {};

  const {
    soefiaAnswer = {}
  } = answerObj;

  const soefiaAnswerPrompObj = soefiaAnswer[promptId] || {}

  const {
    files = []
  } = soefiaAnswerPrompObj;

  // const initialFiles = files.map(({ file }) => file)

  // const onUpdateFileAnswer = (files = []) => {
  //   const formattedFiles = files.map(file => ({ file }))

  //   const updateObj = { ...soefiaAnswer }
  //   if (promptId) {
  //     updateObj[promptId] = { files: formattedFiles }
  //   }

  //   setAnswers({
  //     ...answers,
  //     [questionId]: { soefiaAnswer : updateObj }
  //   })
  // }

  const blobFromUrl = async (mediaBlobUrl) => {
    const response = await fetch(mediaBlobUrl);
    const blob = await response.blob();
    return blob;
  };

  const fileFromBlob = (blob, fileName = "recording.wav") => {
    return new File([blob], fileName, { type: blob.type });
  };

  const initialRecordingFile = (files.map(({ file }) => file))[0]

  const initialRecording = initialRecordingFile ? URL.createObjectURL(initialRecordingFile) : undefined;

  const onUpdateRecordingAnswer = async (mediaBlobUrl = '') => {
    let file;
    if (mediaBlobUrl) {
      try {
        const blob = await blobFromUrl(mediaBlobUrl);
        file = fileFromBlob(blob, "userSoefiaRecording.wav");
      } catch (e) { console.log(e) }

      const formattedFiles = file ? [{ file }] : []

      const updateObj = { ...soefiaAnswer }
      if (promptId) {
        updateObj[promptId] = { files: formattedFiles }
      }

      setAnswers({
        ...answers,
        [questionId]: { soefiaAnswer: updateObj }
      })
    }
    setIsRecordingInProgress(false)
  }

  const onRecordingStarted = () => {
    setIsRecordingInProgress(true)
  }

  const key = `${questionId}-${promptId}`

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column'
    }}>
      <div style={{ 
        fontSize: promptQuestionFontSize, 
        fontWeight: (extraLargeFonts || largeFonts) ? 'bold' : 'bold', 
        marginBottom: (extraLargeFonts || largeFonts) ? '40px' : '20px', whiteSpace: 'pre-wrap', textAlign: 'center' 
      }}>
        {question}
      </div>
      {/* <FileUpload
        key={promptId}
        initialFiles={initialFiles}
        onFilesChanged={onUpdateFileAnswer}
      /> */}
      <AudioRecorder
        key={key}
        autoStartRecording={autoStartRecording}
        initialRecording={initialRecording}
        onRecordingChanged={onUpdateRecordingAnswer}
        onRecordingStarted={onRecordingStarted}
      />
    </div>
  )
}